import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import AuthCallback from "@/pages/AuthCallback";
import Onboarding from "@/pages/Onboarding";
import Home from "@/pages/Home";
import Match from "@/pages/Match";
import Room from "@/pages/Room";
import Profile from "@/pages/Profile";
import Knowledge from "@/pages/Knowledge";
import KnowledgeDetail from "@/pages/KnowledgeDetail";
import Rooms from "@/pages/Rooms";
import Admin from "@/pages/Admin";
import HelperPro from "@/pages/HelperPro";
import Earnings from "@/pages/Earnings";
import SolutionDetail from "@/pages/SolutionDetail";
import Legal from "@/pages/Legal";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
      <Route path="/home" element={<Protected><Home /></Protected>} />
      <Route path="/match/:id" element={<Protected><Match /></Protected>} />
      <Route path="/room/:id" element={<Protected><Room /></Protected>} />
      <Route path="/rooms" element={<Protected><Rooms /></Protected>} />
      <Route path="/knowledge" element={<Knowledge />} />
      <Route path="/knowledge/:case_id" element={<KnowledgeDetail />} />
      <Route path="/solutions/:slug" element={<SolutionDetail />} />
      <Route path="/helper-pro" element={<Protected><HelperPro /></Protected>} />
      <Route path="/earnings" element={<Protected><Earnings /></Protected>} />
      <Route path="/u/:user_id" element={<Protected><Profile /></Protected>} />
      <Route path="/admin" element={<Protected><Admin /></Protected>} />
      <Route path="/legal" element={<Legal />} />
      <Route path="/legal/:slug" element={<Legal />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster richColors position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}
